import { Service } from '../Service';

namespace app.services.organization {

  export class OrganizationService extends Service<any> {
    private currentOrganization;

    constructor(resource: any, rootScope: IRootScope, private configService: app.services.IConfigService, resourceWrapperService: ResourceWrapperService, private httpService: app.services.IHttpWrapperService, stateService: StateService) {
      super({resource, rootScope, resourceWrapperService});

      let organizationResource = this.resource(`${configService.getServerBaseUrlForResource()}/organization/:id`,
        {id: "@id"}, {update: {method: "PUT"}});

      this.itemResource = this.resourceWrapperService.WrapActions(organizationResource);

      rootScope.$on("ClearCurrentSelected", () => this.ClearCurrentOrganization());
      rootScope.$on(EVENTS.LOGIN_REQUIRED, () => this.ClearCurrentOrganization());
    }

    public FindTheme(subdomain) {
      if (subdomain === "app" || subdomain == "beta" || subdomain == "localhost") {
        return {};
      } else {
        return this.httpService.$http({
          method: 'GET',
          url: `${this.configService.getServerBaseUrl()}/organization/theme/${subdomain}`
        })
      }
    }

    public SetCurrentOrganization(organization) {
      console.log("Setting current org: ", organization);

      this.currentOrganization = organization;
      this.rootScope.$broadcast("OrganizationService.CurrentOrganizationChanged", this.currentOrganization);
    };

    public ClearCurrentOrganization() {
      this.currentOrganization = null;
      this.ClearCachedItems();
      this.rootScope.$broadcast("OrganizationService.CurrentOrganizationChanged", this.currentOrganization);
    }

    public GetCurrentOrganization() {
      return this.currentOrganization;
    }
  }

  frontendApp.factory("OrganizationService", ['$resource', '$rootScope', 'ConfigService', 'ResourceWrapperService', 'HttpService', 'StateService', function(resource, rootScope, configService, resourceWrapperService, httpService, stateService) {
    return new OrganizationService(resource, rootScope, configService, resourceWrapperService, httpService, stateService);
  }]);
}
